import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AgentList } from '@/widgets/agent-list';
import { AgentScopeToggle } from '@/widgets/agent-scope-toggle';
export function AgentsPage() {
    return (_jsxs("div", { className: "space-y-4 p-4 md:p-6", children: [_jsxs("header", { className: "flex flex-wrap items-start justify-between gap-3", children: [_jsx("div", { children: _jsx("h1", { className: "text-xl font-semibold", children: "\u0410\u0433\u0435\u043D\u0442\u044B" }) }), _jsx(AgentScopeToggle, {})] }), _jsx(AgentList, {})] }));
}
